import React, { useContext } from "react";
import propTypes from "prop-types";
import { SessionContext } from "../../utility/useSession";
import { AssetLocation, User } from "../../logic/api";
import { FiCheck } from "react-icons/fi";
import flex from "../../styles/flex";
import FloatingInputLabel from "../editable/EditableField/components/FloatingInputLabel";
import { isSysAdmin } from "../../utility/utils";
import { useTranslation } from "react-i18next";

const UserCarParkAccess: React.FunctionComponent<{
    user: User;
    onAccessListUpdate: (accessListString: string) => void
}> = (props) => {
    const session = useContext(SessionContext);
    const { t } = useTranslation();

    const carParks: AssetLocation[] = session.current.site == null ? [] : session.current.site.carParks;

    let defaultCarParkId = -1;
    if (props.user.defaultCarPark != null) {
        defaultCarParkId = props.user.defaultCarPark.id;
    }

    const carParkAccessFromString = (carParkAccess: string) => {
        carParkAccess = carParkAccess || "";
        const carParks: number[] = [];
        for (const cpid of carParkAccess.split("|")) {
            const carParkId = parseInt(cpid);
            if (!isNaN(carParkId)) {
                carParks.push(carParkId);
            }
        }
        return carParks;
    }
    const carParkAccessToString = (carParkIds: number[]) => {
        if (carParkIds == null) {
            return "";
        }
        if (carParkIds.length == 0) {
            return "";
        }
        return `|${carParkIds.join("|")}|`;
    }



    const accessList = carParkAccessFromString(props.user.carParkAccess);
    if (defaultCarParkId != -1) {
        if (accessList.indexOf(defaultCarParkId) == -1) {
            accessList.push(defaultCarParkId);
        }
    }

    const isCurrentUser = session.current.site == null ? false : session.current.site.user.id == props.user.id;

    return <div style={{ marginTop: 20, paddingLeft: 10 }}>
        <FloatingInputLabel label={isCurrentUser ? t("users.carparkAccessRO") : t("users.carparkAccess")}>
            <div style={{ borderRadius: 5, border: "solid 1px lightgray" }}>

                {carParks.map((carPark, i) => {

                    return <div key={i} style={{
                        borderBottom: (i + 1) == carParks.length ? "" : "solid 1px lightgray",
                        padding: 10,
                        cursor: "pointer",
                        opacity: defaultCarParkId == carPark.id ? 0.5 : 1
                    }} onClick={() => {
                        if (defaultCarParkId == carPark.id) {
                            return;
                        }
                        if (isCurrentUser == true && isSysAdmin(session) == false) {
                            return;
                        }
                        // setSelectedDatabaseId(item.id);
                        let acl = [...accessList];
                        const aclIndex = acl.indexOf(carPark.id);
                        if (aclIndex == -1) {
                            acl = [...accessList, carPark.id];
                            //setAccessList(acl);
                        } else {
                            acl.splice(aclIndex, 1);
                            //setAccessList(acl);
                        }
                        props.onAccessListUpdate(carParkAccessToString(acl));
                    }}>
                        <div style={flex.flexRows}>
                            <div style={{ ...flex.flexFill, padding: 2 }}>{carPark.name}</div>
                            {accessList.indexOf(carPark.id) != -1 && (
                                <div style={flex.flexAuto}><div style={{ padding: 2 }}><FiCheck></FiCheck></div></div>
                            )}
                        </div>

                    </div>
                })}
            </div>
        </FloatingInputLabel>
    </div>
}

UserCarParkAccess.propTypes = {
    user: propTypes.any.isRequired,
    onAccessListUpdate: propTypes.func.isRequired
}

export default UserCarParkAccess;